exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thing-title {\n    font-family: Arial;\n    font-weight: bold;\n    font-size: 1.1em;\n    text-transform: uppercase;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/device/ota/ota.component.css
// module id = ../../../../../src/app/device/ota/ota.component.css
// module chunks = main